import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import {
  CuttingMatBaseDialogService,
  CuttingMatBaseGroup,
  CuttingMaterial,
  TypeGroupMaterial
} from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Observable, map } from 'rxjs';
import { ApiLinks } from '../cutting-panel-list/csl.api-links';

@Injectable()
export class CountertopsAvailableComponentsService implements CuttingMatBaseDialogService {
  constructor(private http: HttpClient, ) {}

  public getGroups(groupType: TypeGroupMaterial[]): Observable<CuttingMatBaseGroup[]> {
    return this.http.get<CuttingMatBaseGroup[]>(
      ApiLinks.orderCountertop + '/available-material-groups'
    );
  }

  public getMaterials(
    groupId: number,
    pageSize: number,
    pageIndex: number,
    filterText: string,
    priceFrom: number,
    priceTo: number,
    priceSort: SortDirection
  ): Observable<{ totalCount: number; data: CuttingMaterial[] }> {
    let searchParams: HttpParams = new HttpParams()
      .set('groupId', groupId.toString())
      .set('pageSize', pageSize.toString())
      .set('pageIndex', pageIndex.toString())
      .set('filterText', filterText)
      .set('priceSort', priceSort);

    if (!_.isNil(priceFrom)) {
      searchParams = searchParams.set('priceFrom', priceFrom);
    }
    if (!_.isNil(priceTo)) {
      searchParams = searchParams.set('priceTo', priceTo);
    }

    return this.http
      .get(ApiLinks.orderCountertop + '/available-materials', { params: searchParams })
      .pipe(
        map((response: { materialsDTO: CuttingMaterial[]; materialsCount: number }) => ({
          totalCount: response.materialsCount,
          data: response.materialsDTO,
        }))
      );
  }
}
